<template>
    <div>
        <pagination
            v-if="!showPageLoader && showPagination"
            :pagination="pagination"
            @pagination-changed="paginationChanged"
            @button-clicked-previous="applySearch('previous')"
            @button-clicked-next="applySearch('next')"
        ></pagination>
        <status-update-popup @updateStatus="submit"></status-update-popup>
        <base-toast></base-toast>
    </div>
</template>

<script>
import pagination from '@/components/Pagination.vue'
import { mapGetters } from 'vuex'
import statusUpdatePopup from '@/components/popups/StatusUpdatePopup.vue'
import resource from '@/api/resource'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        pagination,
        statusUpdatePopup,
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        path: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
        reset: {
            type: Number,
        },
        showPagination: {
            type: Boolean,
            required: true,
        },
        reload: {
            type: Number,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            resourceApi: null,
            pagination: {},
        }
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'dataSegmentId',
            'showPageLoader',
            'selectedItem',
            'onSubmit',
        ]),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reset(value) {
            this.applySearch()
        },
        dataSegmentId(value) {
            if (value) {
                this.applySearch()
            }
        },
        reload(value) {
            this.getRecords()
        },
        onSubmit(value) {
            if (value) {
                this.submit(value)
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    created() {
        this.resourceApi = new resource(this.path)
    }, // End of Component > created

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.dataSegmentId) {
            this.getRecords()
        }
        const page = this.$store.getters.getField('pagination' + this.path)

        if (page) {
            this.paginationChanged(page)
        }
    }, // End of Component > mounted
    beforeDestroy() {
        this.$store.dispatch(`setData`, [])
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getRecords() {
            this.$store.dispatch(`setData`, [])
            this.$store.commit('showPageLoader', true)
            try {
                this.query.dataSegmentId = this.dataSegmentId
                let { data } = await this.resourceApi.list(this.query)
                if (data && data.data) {
                    if (data.data.length) {
                        // Get all data in items
                        this.$store.dispatch(`setData`, data.data)
                    }

                    if (data.pagination) {
                        let pagination = data.pagination
                        this.$store.commit(`setTotalRecords`, pagination.total)
                        // Show Pagination
                        this.query.startAt = pagination.current
                        this.pagination = pagination
                        this.pagination.perPage = this.query.perPage
                        this.pagination.totalRecords = data.data.length
                    }
                }

                // False the page loader after the list has been loaded
                this.$store.commit('showPageLoader', false)
                this.$store.commit('setLoading', false)
            } catch (error) {
                this.$store.commit('showPageLoader', false)
                this.$store.dispatch(`setData`, [])
                this.$store.commit('setLoading', false)
                // this.$store.commit('setError', error)
            }
        },
        paginationChanged(limit) {
            this.query.perPage = limit || 10
            this.query.startAt = 1
            this.pagination.perPage = limit || 10
            this.$store.commit('updateField', {
                key: 'pagination' + this.path,
                value: limit,
            })
            this.getRecords()
        }, // End of paginationChanged() method
        //apply filters and get matching records
        applySearch(type) {
            this.pagination.perPage = this.query.perPage
            this.query.startAt = 1
            if (type && type == 'next') {
                this.query.startAt = this.pagination.next
            }

            if (type && type == 'previous') {
                this.query.startAt = this.pagination.current - 1
            }

            this.$store.dispatch(`setData`, [])
            //this.$store.commit('setLoading', true)
            this.getRecords()
        }, // End of applySearch() method

        async submit(record) {
            this.$store.commit('setLoading', true)
            let item = {}
            if (record.type && record.type == 'status') {
                item = JSON.parse(JSON.stringify(this.selectedItem))
                item.status = record.status
            } else {
                item = record
                delete item.status
            }

            try {
                if (item._id) {
                    var { data } = await this.resourceApi.update(item._id, item)
                } else {
                    item.dataSegmentId = this.dataSegmentId
                    var { data } = await this.resourceApi.store(item)
                }
                if (data) {
                    this.$store.commit('setSuccess', data.message)
                    //setTimeout(this.$parent.reset = new Date().getTime(), 3000)
                }
            } catch (error) {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', error)
            }
        },
    },
}
</script>
